import { defineComponent as _defineComponent } from 'vue'
import { TUITranslateService, TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatDefaultContent',
  setup(__props) {

const isOfficial = TUIStore.getData(StoreName.APP, "isOfficial");

return { __sfc: true,isOfficial, TUITranslateService }
}

})